/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthMemberLogoutResponse } from "./AuthMemberLogoutResponse";

export type AuthMemberLogoutResponseApiRespoonse = {
  data?: AuthMemberLogoutResponse;
  status?: AuthMemberLogoutResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AuthMemberLogoutResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
